angular.module('impactx.purchaseorder').controller('PurchaseOrderSupplierListCtrl',
    ['selectedListItems', 'dataGen', 'ToastService', '$route', '$mdDialog', '$redirect', 'PurchaseOrderService',
        PurchaseOrderSupplierListCtrl]);

function PurchaseOrderSupplierListCtrl(selectedListItems, dataGen, ToastService, $route, $mdDialog, $redirect, PurchaseOrderService) {
    var ctrl = this;
    var downloadAndPrintArray = [];

    this.canEdit = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canEdit.value;
    };

    this.isCancel = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().isCancel && selectedListItems.getFirstSelectedItem().isCancel.value;
    };

    this.canDownloadCancel = function () {
        return ctrl.canEdit() && ctrl.isCancel() && ctrl.canDownload();
    };

    this.canDownloadOrder = function () {
        return !ctrl.isCancel() && ctrl.canDownload();
    };

    this.canDownload = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDownload && selectedListItems.getFirstSelectedItem().canDownload.value;
    };

    this.canNewDeliveryNote = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDeliveryNoteSupplier.value;
    };

    this.hasRightOrderStatusForActions = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().orderStatusForAction.value &&
            selectedListItems.getFirstSelectedItem().canEdit.value &&
            !selectedListItems.getFirstSelectedItem().isCancel.value;

    };

    this.canReOpenInvoice = function () {
        if (!selectedListItems.isMultiSelection()) {
            return false;
        }
        else {
            var selectedItems = selectedListItems.getSelectedItems();
            var i = 0;
            while (i < selectedItems.length) {
                var selectedItem = selectedItems[i];
                //if (!selectedItem.invoiceCompleted || !selectedItem.orderStatusForAction || !selectedItem.canEdit)
                if (!selectedItem.invoiceCompleted.value || !selectedItem.canReOpenInvoice.value || !selectedItem.canEdit.value) {
                    return false;
                }
                i++;
            }
        }
        return true;
    };

    this.canCloseInvoice = function () {
        if (!selectedListItems.isMultiSelection()) {
            return false;
        }
        else {
            var selectedItems = selectedListItems.getSelectedItems();
            var i = 0;
            while (i < selectedItems.length) {
                var selectedItem = selectedItems[i];
                //if (selectedItem.invoiceCompleted || !selectedItem.orderStatusForAction || !selectedItem.canEdit)
                if (selectedItem.invoiceCompleted.value || !selectedItem.canCloseInvoice.value || !selectedItem.canEdit.value || selectedListItems.getFirstSelectedItem().isCancel.value) {
                    return false;
                }
                i++;
            }
        }
        return true;
    };

    this.getDeliveryAdviceSupplierLink = function () {
        return "deliveryadvicesupplier/" + selectedListItems.getFirstSelectedId();
    };

    this.getDeliveryNoteLink = function () {
        return "deliverynote/" + selectedListItems.getFirstSelectedId();
    };

    this.getOrderConfirmationLink = function () {
        return "orderconfirmationsupplier/" + selectedListItems.getFirstSelectedId();
    };

    this.getNewInvoiceLink = function () {
        return "invoiceview/0/0/" + selectedListItems.getFirstSelectedId() + "/0";
    };

    this.getOrderLink = function () {
        return "purchaseorderdetailsupplier/" + selectedListItems.getFirstSelectedId();
    };

    this.createInvoice = function (event, trns, additionalFields) {
        var firstSelectedItem = selectedListItems.getFirstSelectedItem();
        $mdDialog.show({
            controller: "InvoiceCreationCtrl",
            controllerAs: "invoiceCreationCtrl",
            templateUrl: "modules/invoice/templates/invoicecreation.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                actionLabel: trns.newInvoice,
                withOrderRefLabel: trns.withOrderRef,
                noOrderRefLabel: trns.noOrderRef,
                lotLabel: trns.lot,
                orderLabel: trns.order,
                forwardLabel: trns.forward,
                abortLabel: trns.abort,
                confirmLabel: trns.confirm,
                requiredLabel: trns.required,
                noSelectedItemMessage: trns.noSelectedItemMessage,
                invoiceReceiverLabel: trns.invoiceReceiver,
                orderTemplate: additionalFields.orderTemplate,
                creditNote: false,
                preSetPoh: {
                    id: firstSelectedItem.id,
                    value: firstSelectedItem.orderNumbers + " (" + firstSelectedItem.companyname + ")"
                }
            }
        })
            .then(function (answer) {
                if (answer.deliveryDateValue) {
                    $redirect.redirectTo(null, "invoiceview/0/" + answer.lotSupplierId + "/" + answer.pohId + "/" +
                        answer.orderComId + "/" + answer.deliveryDateValue + "/" + new Date().getTime())
                }
                else {
                    $redirect.redirectTo(null, "invoiceview/0/" + answer.lotSupplierId + "/" + answer.pohId + "/" +
                        answer.orderComId + "/" + new Date().getTime())
                }
            }, function () {
            });
    };

    this.closeInvoice = function () {
        PurchaseOrderService.closeInvoice(selectedListItems.getSelectedIds(), true);
    };

    this.reOpenInvoice = function () {
        PurchaseOrderService.reopenInvoice(selectedListItems.getSelectedIds(), true);
    };

    this.getDownloadAndPrintArray = function () {
        if (downloadAndPrintArray.length != 1 || selectedListItems.getFirstSelectedId() != downloadAndPrintArray[0]) {
            downloadAndPrintArray = [selectedListItems.getFirstSelectedId()];
        }
        return downloadAndPrintArray;
    };

    ctrl.updateItem = function () {
        var params = {
            id: selectedListItems.getFirstSelectedItem().id
        };
        var res = {};
        dataGen.getData(res, params, '/purchaseorder/supplier/list/refreshone').then(function () {
            if (res && res.data) {
                refreshSingleItem(selectedListItems.getFirstSelectedItem(), res.data);
            }
        });
    };

    var refreshSingleItem = function (item, data) {
        item.status = data.status;
        item.orderNumbers = data.orderNumbers;
        item.supplier = data.supplier;
        item.supplierFullName = data.supplierFullName;
        item.sentDate = data.sentDate;
        item.companyname = data.companyname;
        item.companyFullName = data.companyFullName;
        item.supplieruser = data.user;
        item.contract = data.contract;
        item.contractNo = data.contractNo;
        item.pos_count = data.pos_count;
        item.amount = data.amount;
        item.positionSort = data.positionSort;
        item.amountSort = data.amountSort;
        item.orderStatusForAction.value = data.orderStatusForAction;
        item.canEdit.value = data.canEdit;
        item.invoiceCompleted.value = data.invoiceCompleted;
        item.canCloseInvoice.value = data.canCloseInvoice;
        item.canReOpenInvoice.value = data.canReopenInvoice;
        item.isCancel.value = data.isCancel;
    };

    ctrl.canJumpToCancelRequest = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().crhId > 0;
    };

    ctrl.getCancelRequestLink = function () {
        return "crhdetailssupplier/" + selectedListItems.getFirstSelectedItem().crhId;
    };

    ctrl.getPDFToken = function () {
        return getPrintToken('pdf');
    }

    ctrl.getCBLToken = function () {
        return getPrintToken('cbl');
    }

    function getPrintToken(identifier) {
        return selectedListItems.getFirstSelectedItem().printTokens[identifier];
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: ctrl.getOrderLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'PurchaseOrderSupplier'
        },
        {
            label: "cancelRequest",
            linkFunction: ctrl.getCancelRequestLink,
            type: 'link',
            condition: ctrl.canJumpToCancelRequest,
            process: 'CancellationRequestSupplier'
        },
        {
            label: "download",
            action: ctrl.updateItem,
            condition: ctrl.canDownloadOrder,
            type: 'print',
            params: {
                printTokenFunction: ctrl.getPDFToken,
                entryPoint: "acknowledged"
            }
        },
        {
            label: "downloadCancel",
            action: ctrl.updateItem,
            condition: ctrl.canDownloadCancel,
            type: 'print',
            params: {
                printTokenFunction: ctrl.getPDFToken,
                entryPoint: "acknowledged"
            }
        },
        {
            label: "orderConfirmation",
            linkFunction: ctrl.getOrderConfirmationLink,
            type: 'link',
            condition: ctrl.hasRightOrderStatusForActions,
            process: 'ViewOrderConfirmationSupplier'
        },
        {
            label: "deliveryAdvice",
            linkFunction: ctrl.getDeliveryAdviceSupplierLink,
            type: 'link',
            condition: ctrl.hasRightOrderStatusForActions,
            process: 'ViewDeliveryAdviceSupplier'
        },
        {
            label: "createDelNote",
            linkFunction: ctrl.getDeliveryNoteLink,
            type: 'link',
            condition: ctrl.canNewDeliveryNote,
            process: 'EditDeliveryNote'
        },
        {
            label: "newInvoice",
            action: ctrl.createInvoice,
            condition: ctrl.hasRightOrderStatusForActions,
            process: 'EditInvoice'
        },
        {label: "closeInvoice", action: ctrl.closeInvoice, condition: ctrl.canCloseInvoice, process: 'CloseInvoice'},
        {
            label: "reOpenInvoice",
            action: ctrl.reOpenInvoice,
            condition: ctrl.canReOpenInvoice,
            process: 'ReopenInvoice'
        },
        {
            label: "downloadCBL",
            action: ctrl.updateItem,
            condition: ctrl.canDownloadOrder,
            type: 'download',
            params: {
                printTokenFunction: ctrl.getCBLToken,
                entryPoint: "acknowledged",
                contentType: "application/xml"
            }
        },
        {
            label: "downloadCancelCBL",
            action: ctrl.updateItem,
            condition: ctrl.canDownloadCancel,
            type: 'download',
            params: {
                printTokenFunction: ctrl.getCBLToken,
                entryPoint: "acknowledged",
                contentType: "application/xml"
            }
        }
    ];

    this.meta = {
        rowTemplate: 'modules/purchaseorder/templates/purchaseordersupplierlist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/purchaseorder/supplier/list',
        ctrl: this,
        id: "purchaseordersupplierlist",
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}